<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-ibase-cru-modal-content [showDefaultFormFooter]="true">
        <div class="hcol-flex">
            <div class="hcol-50 floatingLabelContainer p-1">
                <p-floatlabel variant="on">
                    <p-select
                        inputId="type"
                        [autoDisplayFirst]="false"
                        [options]="typeOfLocationOptions"
                        formControlName="type"
                        optionLabel="label"
                        optionValue="value"
                        appendTo="body"
                    ></p-select>
                    <label for="type">Type</label>
                </p-floatlabel>

                @if (LocationUtils.isGlobalLocation(this.item)) {
                    <p-message severity="info">This is the global location for the selected organization</p-message>
                } @else {
                    <p-floatlabel variant="on">
                        <p-treeSelect
                            formControlName="parent"
                            containerStyleClass="width-form"
                            [options]="parentsTreeRoot.children"
                            title="Select a parent for this location"
                            emptyMessage="No parent location found"
                            [filter]="true"
                            [filterInputAutoFocus]="true"
                            selectionMode="single"
                            [showClear]="isCreationMode"
                            appendTo="body"
                            [virtualScroll]="true"
                            [virtualScrollItemSize]="35"
                            [virtualScrollOptions]="{scrollHeight: '20rem'}"
                        >
                            <ng-template pTemplate="default" let-node>
                                <div style="display: flex; align-items: center; gap: 0.5rem">
                                    <span [class]="LocationUtils.getIconForType(node.type)"></span>
                                    <span>{{ node.label }}</span>
                                    @if (node.key === currentParentUUID) {
                                        <p-tag value="Current parent" severity="info" [rounded]="true"></p-tag>
                                    }
                                </div>
                            </ng-template>
                        </p-treeSelect>
                        <label for="parent">Parent location</label>
                    </p-floatlabel>
                }

                <p-floatlabel variant="on">
                    <input id="name" type="text" pInputText formControlName="name" />
                    <label for="name">Name</label>
                </p-floatlabel>

                <p-floatlabel variant="on">
                    <textarea
                        id="description"
                        rows="3"
                        cols="30"
                        pInputTextarea
                        formControlName="description"
                    ></textarea>
                    <label for="description">Description</label>
                </p-floatlabel>
            </div>
            <div class="hcol-50 floatingLabelContainer">
                @let vec1Type = CPMLocationApiUtils.getVector1Type(form.controls['type'].value);
                @let vec1Spec =
                    CPMLocationApiUtils.getVectorTypeComponentSpec(vec1Type, form.controls['type'].value, 1);

                @if (vec1Type !== ECPMLocationVectorTypeApiEnum.NONE) {
                    <p-panel [header]="vec1Spec.hint">
                        <div class="floatingLabelContainer">
                            @if (vec1Spec.components[0].enabled) {
                                <p-inputgroup>
                                    <p-floatlabel variant="on">
                                        <p-inputnumber
                                            inputId="x1"
                                            formControlName="x1"
                                            mode="decimal"
                                            [useGrouping]="false"
                                            [minFractionDigits]="vec1Spec.components[0].dmin"
                                            [maxFractionDigits]="vec1Spec.components[0].dmax"
                                        />
                                        <label for="x1">{{ vec1Spec.components[0].hint }}</label>
                                    </p-floatlabel>
                                    <p-inputgroup-addon>{{ vec1Spec.components[0].unitHint }}</p-inputgroup-addon>
                                </p-inputgroup>
                            }
                            @if (vec1Spec.components[1].enabled) {
                                <p-inputgroup>
                                    <p-floatlabel variant="on">
                                        <p-inputnumber
                                            inputId="y1"
                                            formControlName="y1"
                                            mode="decimal"
                                            [useGrouping]="false"
                                            [minFractionDigits]="vec1Spec.components[1].dmin"
                                            [maxFractionDigits]="vec1Spec.components[1].dmax"
                                        />
                                        <label for="y1">{{ vec1Spec.components[1].hint }}</label>
                                    </p-floatlabel>
                                    <p-inputgroup-addon>{{ vec1Spec.components[1].unitHint }}</p-inputgroup-addon>
                                </p-inputgroup>
                            }
                            @if (vec1Spec.components[2].enabled) {
                                <p-inputgroup>
                                    <p-floatlabel variant="on">
                                        <p-inputnumber
                                            inputId="z1"
                                            formControlName="z1"
                                            mode="decimal"
                                            [useGrouping]="false"
                                            [minFractionDigits]="vec1Spec.components[2].dmin"
                                            [maxFractionDigits]="vec1Spec.components[2].dmax"
                                        />
                                        <label for="z1">{{ vec1Spec.components[2].hint }}</label>
                                    </p-floatlabel>
                                    <p-inputgroup-addon>{{ vec1Spec.components[2].unitHint }}</p-inputgroup-addon>
                                </p-inputgroup>
                            }
                        </div>
                    </p-panel>
                }

                @let vec2Type = CPMLocationApiUtils.getVector2Type(form.controls['type'].value);
                @let vec2Spec =
                    CPMLocationApiUtils.getVectorTypeComponentSpec(vec2Type, form.controls['type'].value, 2);

                @if (vec2Type !== ECPMLocationVectorTypeApiEnum.NONE) {
                    <p-panel [header]="vec2Spec.hint">
                        <div class="floatingLabelContainer">
                            @if (vec2Spec.components[0].enabled) {
                                <p-inputgroup>
                                    <p-floatlabel variant="on">
                                        <p-inputnumber
                                            inputId="x2"
                                            formControlName="x2"
                                            mode="decimal"
                                            [useGrouping]="false"
                                            [minFractionDigits]="vec2Spec.components[0].dmin"
                                            [maxFractionDigits]="vec2Spec.components[0].dmax"
                                        />
                                        <label for="x2">{{ vec2Spec.components[0].hint }}</label>
                                    </p-floatlabel>
                                    <p-inputgroup-addon>
                                        {{ vec2Spec.components[0].unitHint }}
                                    </p-inputgroup-addon>
                                </p-inputgroup>
                            }
                            @if (vec2Spec.components[1].enabled) {
                                <p-inputgroup>
                                    <p-floatlabel variant="on">
                                        <p-inputnumber
                                            inputId="y2"
                                            formControlName="y2"
                                            mode="decimal"
                                            [useGrouping]="false"
                                            [minFractionDigits]="vec2Spec.components[1].dmin"
                                            [maxFractionDigits]="vec2Spec.components[1].dmax"
                                        />
                                        <label for="y2">{{ vec2Spec.components[1].hint }}</label>
                                    </p-floatlabel>
                                    <p-inputgroup-addon>{{ vec2Spec.components[1].unitHint }}</p-inputgroup-addon>
                                </p-inputgroup>
                            }
                            @if (vec2Spec.components[2].enabled) {
                                <p-inputgroup>
                                    <p-floatlabel variant="on">
                                        <p-inputnumber
                                            inputId="z2"
                                            formControlName="z2"
                                            mode="decimal"
                                            [useGrouping]="false"
                                            [minFractionDigits]="vec2Spec.components[2].dmin"
                                            [maxFractionDigits]="vec2Spec.components[2].dmax"
                                        />
                                        <label for="z2">{{ vec2Spec.components[2].hint }}</label>
                                    </p-floatlabel>
                                    <p-inputgroup-addon>
                                        {{ vec2Spec.components[2].unitHint }}
                                    </p-inputgroup-addon>
                                </p-inputgroup>
                            }
                        </div>
                    </p-panel>
                }

                @if (CPMLocationApiUtils.hasSlotCount(form.controls['type'].value)) {
                    <p-panel header="Slot count">
                        <div class="floatingLabelContainer">
                            <p-inputgroup>
                                <p-floatlabel variant="on">
                                    <p-inputnumber
                                        inputId="slot_count"
                                        formControlName="slot_count"
                                        mode="decimal"
                                        [useGrouping]="false"
                                        [minFractionDigits]="0"
                                        [maxFractionDigits]="0"
                                    />
                                    <label for="slot_count">Slot count</label>
                                </p-floatlabel>
                                <p-inputgroup-addon> u </p-inputgroup-addon>
                            </p-inputgroup>
                        </div>
                    </p-panel>
                }
            </div>
        </div>
    </app-ibase-cru-modal-content>
</form>
